import { render, staticRenderFns } from "./LocationAccordion.vue?vue&type=template&id=18234e6a&scoped=true&"
import script from "./LocationAccordion.vue?vue&type=script&lang=js&"
export * from "./LocationAccordion.vue?vue&type=script&lang=js&"
import style0 from "./LocationAccordion.vue?vue&type=style&index=0&id=18234e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18234e6a",
  null
  
)

export default component.exports